// extracted by mini-css-extract-plugin
module.exports = {"heading":"TermsOfServicePage_heading__3p8IC","content":"TermsOfServicePage_content__2lKi3"};